import type { HTMLAttributes } from "react";
import { Glyph } from "./Glyph";
import type { GlyphName } from "./Glyph";
import { cn } from "@/lib/utils";
import { statusTone } from "./statusTone.constants";
export { statusTone } from "./statusTone.constants";
const TONE_CLASS = {
  neutral: "bg-offwhite text-tag-ink",
  muted: "bg-offwhite-2 text-ink-2",
  blue: "bg-tone-blue text-tag-ink",
  green: "bg-tone-green text-tag-ink",
  yellow: "bg-tone-yellow text-tag-ink",
  peach: "bg-tone-peach text-tag-ink",
  cream: "bg-tone-cream text-tag-ink",
  lilac: "bg-tone-lilac text-tag-ink",
  red: "bg-tone-red text-tone-red-ink",
  ink: "bg-ink text-surface"
} as const;
export type TagTone = keyof typeof TONE_CLASS;
export function Tag({
  tone = "neutral",
  icon,
  className,
  children,
  ...props
}: HTMLAttributes<HTMLSpanElement> & {
  tone?: TagTone;
  icon?: GlyphName;
}) {
  return <span className={cn("inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-full px-2.5 text-caption font-medium", TONE_CLASS[tone], className)} {...props} data-sentry-component="Tag" data-sentry-source-file="Tag.tsx">
            {icon ? <Glyph name={icon} className="h-2.5 w-2.5" /> : null}
            {children}
        </span>;
}
export function StatusTag({
  status,
  label,
  className
}: {
  status: string | null | undefined;
  label: string;
  className?: string;
}) {
  return <Tag tone={statusTone(status)} className={className} data-sentry-element="Tag" data-sentry-component="StatusTag" data-sentry-source-file="Tag.tsx">
            {label}
        </Tag>;
}